import { request } from './apiClient';

/** Empresa do usuário, como vem do login. */
export interface CompanySummary {
  readonly id: string;
  readonly tradeName: string;
  readonly type: 'Buyer' | 'Supplier' | 'Hybrid';
  readonly role: string;
  readonly isDefault: boolean;
}

export interface AuthenticatedUser {
  readonly id: string;
  readonly name: string;
  readonly email: string;
}

export interface Session {
  readonly accessToken: string;
  readonly expiresIn: number;
  readonly tokenType: string;
  readonly user: AuthenticatedUser;
  readonly companies: readonly CompanySummary[];
  readonly activeCompanyId: string | null;
  readonly emailVerified: boolean;
}

export interface RegisterResult {
  readonly userId: string;
  readonly emailVerificationRequired: boolean;
}

/** Perfil de atuação da empresa, escolhido no cadastro. */
export type CompanyProfile = 'Buyer' | 'Supplier' | 'Hybrid';

export interface RegisterInput {
  readonly name: string;
  readonly email: string;
  readonly password: string;
  readonly companyName: string;
  readonly cnpj: string;
  readonly profile: CompanyProfile;
}

export const authApi = {
  login: (email: string, password: string, deviceName: string) =>
    request<Session>('/auth/login', {
      method: 'POST',
      body: { email, password, deviceName },
    }),

  register: (input: RegisterInput) =>
    request<RegisterResult>('/auth/register', { method: 'POST', body: input }),

  verifyEmail: (token: string) =>
    request<void>('/auth/verify-email', { method: 'POST', body: { token } }),

  resendVerification: (email: string) =>
    request<void>('/auth/resend-verification', { method: 'POST', body: { email } }),

  forgotPassword: (email: string) =>
    request<void>('/auth/forgot-password', { method: 'POST', body: { email } }),

  resetPassword: (token: string, newPassword: string) =>
    request<void>('/auth/reset-password', { method: 'POST', body: { token, newPassword } }),

  /**
   * Restaura a sessão a partir do cookie, no carregamento da página.
   *
   * É o que faz o usuário continuar logado depois de um F5 sem que o token
   * precise ficar em `localStorage`, onde um XSS o alcançaria.
   */
  refresh: () => request<Session>('/auth/refresh', { method: 'POST', skipRefresh: true }),

  logout: () => request<void>('/auth/logout', { method: 'POST' }),
};
